import React, { useState, useEffect } from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import baseURL from '../Components/url';

const routeToModule = {
    '/dashboard/reportes': 'reportes',
    '/dashboard/reservas': 'reservas',
    '/dashboard/pacientes': 'pacientes',
    '/dashboard/profesionales': 'profesionales',
    '/dashboard/productos': 'productos',
    '/dashboard/pedidos': 'pedidos',
    '/dashboard/inventarios': 'inventarios',
    '/dashboard/gastos': 'gastos',
    '/dashboard/evaluaciones': 'evaluaciones',
    '/dashboard/medios-pago': 'medios-pago',
    '/dashboard/categorias': 'categorias',
    '/dashboard/banners': 'banners',
    '/dashboard/contacto': 'contacto',
    '/dashboard/usuarios': 'usuarios',
    '/dashboard/codigos': 'codigos',
    '/dashboard/testimonios': 'testimonios',
    '/dashboard/sucursales': 'sucursales',
    '/dashboard/horarios': 'horarios',
    '/dashboard/pwa': 'pwa',
    '/dashboard/configuracion': 'configuracion'
};

export default function MainLayout() {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                //userlogued
                const response = await fetch(`${baseURL}/userLogued.php`, {
                    credentials: 'include'
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setUsuario(data);
                if (data && data.idUsuario) {
                    sessionStorage.setItem('usuario', JSON.stringify(data));
                } else {
                    sessionStorage.removeItem('usuario');
                }
                setLoading(false);

            } catch (error) {
                console.error('Error al obtener datos:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const hasPermission = (module, action) => {
        if (!usuario || !usuario.rol) return false;
        if (usuario.rol === 'admin') return true;
        if (usuario.rol === 'empleado') {
            let permisos = usuario.permisos;
            if (typeof permisos === 'string') {
                try {
                    permisos = JSON.parse(permisos);
                } catch (e) {
                    permisos = {};
                }
            }
            if (!permisos) return false;
            const modPerm = permisos[module];
            if (modPerm) {
                return !!modPerm[action];
            }
        }
        return false;
    };

    if (loading) {
        return <Spiner />;
    }

    if (!usuario.idUsuario) {
        return <Auth />;
    }

    const activeModule = routeToModule[location.pathname];
    if (activeModule && !hasPermission(activeModule, 'ver')) {
        return <Navigate to="/dashboard" replace />;
    }

    const canEditActiveModule = activeModule ? hasPermission(activeModule, 'editar') : true;

    return (
        <div>
            <div className={!canEditActiveModule ? 'no-edit-module' : ''}>
                <Outlet context={{ usuario }} />
            </div>
        </div>
    );
}
